export default __webpack_public_path__ + "static/media/sellerNet.5f6bbf7a.svg";